module.exports = __webpack_public_path__ + "static/img/科普馆.4047edab.png";